import { render, staticRenderFns } from "./testing.vue?vue&type=template&id=cf90dcd0&"
import script from "./testing.vue?vue&type=script&lang=js&"
export * from "./testing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports